var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_442_5011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9625 0.75C7.05001 0.75 2.88751 3.9 1.35001 8.25H22.575C21.0375 3.9 16.875 0.75 11.9625 0.75Z",
    fill: "#3E4347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9625 23.25C16.875 23.25 21.0375 20.1375 22.575 15.75H1.35001C2.88751 20.1375 7.05001 23.25 11.9625 23.25Z",
    fill: "#FFE62E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.34999 8.25C0.937494 9.4125 0.712494 10.6875 0.712494 12C0.712494 13.3125 0.937494 14.5875 1.34999 15.75H22.575C22.9875 14.5875 23.2125 13.3125 23.2125 12C23.2125 10.6875 22.9875 9.4125 22.575 8.25H1.34999Z",
    fill: "#ED4C5C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_442_5011"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGe);
export default __webpack_public_path__ + "static/media/ge.075c3c55.svg";
export { ForwardRef as ReactComponent };